// Shared API client
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
  withCredentials: true,
});

export const RETAILER_COLORS = {
  target: "#CC0000",
  walmart: "#0071CE",
  bestbuy: "#0046BE",
  amazon: "#FF9900",
  gamestop: "#E51F2A",
  tcgplayer: "#F4B223",
  ebay: "#E53238",
  pokemoncenter: "#FFCB05",
  jbhifi: "#FFF000",
  kmart_au: "#E60028",
  target_au: "#E4002B",
  bigw: "#0099D8",
  ebgames_au: "#ED1C24",
  zing: "#FF6B00",
  gametraders: "#1E88E5",
};

export function formatRelative(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 5) return "just now";
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export function formatPrice(p, currency = "USD") {
  if (p == null) return "—";
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(p);
  } catch {
    return `$${p.toFixed(2)}`;
  }
}
